import React from 'react';
import classNames from 'classnames';
import { Formik, Form, Field } from 'formik';

import styles from './commentInputStyles';

import CommentField from 'buyside/components/presentation/Form/Field/CommentField/commentField';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Button, { BUTTON_TYPES, BUTTON_SIZES } from 'buyside/components/presentation/Button/button';

class CommentInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: { anonymous: false, body: '' }
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleUnload(event) {
    if (this.fieldInput.value) {
      const text =
        "You still haven't submitted what you were writing. Are you sure you want to leave this page?";
      event.returnValue = text;
      return text;
    }
    return;
  }

  handleSubmit(values, { resetForm }) {
    const handleComment = this.props.handleComment;
    return handleComment(values).then(() => resetForm(this.state.initialValues));
  }

  componentDidMount() {
    this.boundHandleUnload = this.handleUnload.bind(this);
    window.addEventListener('beforeunload', this.boundHandleUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.boundHandleUnload);
  }

  renderAllocatorNotification() {
    return (
      <span className={styles.allocatorNotice}>
        As an allocator, all of your comments are anonymous unless you're commenting on a fund
        profile.
      </span>
    );
  }

  renderAnonCheckbox() {
    return (
      <span className={styles.checkBoxArea}>
        <label className={styles.checkBoxLabel}>
          <Field component="input" type="checkbox" name="anonymous" data-heap="anonymous-comment" />{' '}
          Post this comment anonymously
        </label>
      </span>
    );
  }

  render() {
    const {
      profileImageUrl,
      formId,
      allowAnonymousComment,
      mentionables,
      showAllocatorNotification
    } = this.props;

    return (
      <div id={formId}>
        <div className={styles.commentInput}>
          <ProfileImage source={profileImageUrl} size={'tiny'} className={styles.profileImage} />
          <div className={styles.commentEntry}>
            <Formik
              onSubmit={this.handleSubmit}
              initialValues={this.state.initialValues}
              render={({ isSubmitting, dirty }) => (
                <Form>
                  <Field
                    analyticsTag="comment-text-field"
                    id={formId + '-textarea'}
                    name="body"
                    component={CommentField}
                    mentionables={mentionables}
                    disabled={isSubmitting}
                    note="Note: Type '@' to tag participants in this comment thread.
                    Tagged members will be notified."
                  />
                  <div className={styles.commentNavArea}>
                    <Button
                      isLoading={isSubmitting}
                      disabled={!dirty}
                      text="Post"
                      size={BUTTON_SIZES.TINY}
                      type={BUTTON_TYPES.PRIMARY}
                      analyticsTag="post-comment"
                    />
                    <span
                      className={classNames(styles.transition, {
                        [styles.hidden]: !this.state.popoverOpen && !dirty
                      })}
                    >
                      {showAllocatorNotification ? this.renderAllocatorNotification() : null}
                      {allowAnonymousComment ? this.renderAnonCheckbox() : null}
                    </span>
                  </div>
                </Form>
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CommentInput;
